import { IIconBase } from '..'

const truckIcon = ({
  color = '#333752',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15 2.07617V12.0762C15 13.1762 14.1 14.0762 13 14.0762H2V6.07617C2 3.86617 3.79 2.07617 6 2.07617H15Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22 14.0762V17.0762C22 18.7362 20.66 20.0762 19 20.0762H18C18 18.9762 17.1 18.0762 16 18.0762C14.9 18.0762 14 18.9762 14 20.0762H10C10 18.9762 9.1 18.0762 8 18.0762C6.9 18.0762 6 18.9762 6 20.0762H5C3.34 20.0762 2 18.7362 2 17.0762V14.0762H13C14.1 14.0762 15 13.1762 15 12.0762V5.07617H16.84C17.56 5.07617 18.22 5.46618 18.58 6.08618L20.29 9.07617H19C18.45 9.07617 18 9.52617 18 10.0762V13.0762C18 13.6262 18.45 14.0762 19 14.0762H22Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8 22.0762C9.10457 22.0762 10 21.1807 10 20.0762C10 18.9716 9.10457 18.0762 8 18.0762C6.89543 18.0762 6 18.9716 6 20.0762C6 21.1807 6.89543 22.0762 8 22.0762Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16 22.0762C17.1046 22.0762 18 21.1807 18 20.0762C18 18.9716 17.1046 18.0762 16 18.0762C14.8954 18.0762 14 18.9716 14 20.0762C14 21.1807 14.8954 22.0762 16 22.0762Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22 12.0762V14.0762H19C18.45 14.0762 18 13.6262 18 13.0762V10.0762C18 9.52617 18.45 9.07617 19 9.07617H20.29L22 12.0762Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default truckIcon
